// Reglas de contraseña (mismas que backend/src/controllers/authController.js)
export const REGLAS_PASSWORD = [
  { id: "largo", texto: "Mínimo 8 caracteres", cumple: (p) => p.length >= 8 },
  { id: "numero", texto: "Al menos un número", cumple: (p) => /\d/.test(p) },
];

export const MENSAJE_REGLAS = "La contraseña debe tener mínimo 8 caracteres e incluir al menos un número";

export const passwordValida = (p = "") =>
  REGLAS_PASSWORD.every((r) => r.cumple(p)) && p.length <= 72;
